import { Ellipsis, ExternalLink, LayersPlus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EnrichedLifeglovLinerStock } from '../../api/lifeglov-liner-stock';
import { IconButton } from '../../components/Button/IconButton';
import { DialogTrigger } from '../../components/Dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '../../components/DropdownMenu';
import { EditLifeglovLinerStockDialog } from './EditLifeglovLinerStockDialog';

export interface LifeglovLinerStockTableActionsProps {
  stock: EnrichedLifeglovLinerStock;
}

export function LifeglovLinerStockTableActions({ stock }: LifeglovLinerStockTableActionsProps) {
  return (
    <EditLifeglovLinerStockDialog stock={stock}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton icon={Ellipsis} variant="transparent" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DialogTrigger asChild>
            <DropdownMenuItem>
              <LayersPlus />
              <span>Edit Stock</span>
            </DropdownMenuItem>
          </DialogTrigger>
          <DropdownMenuItem asChild>
            <Link to="/admin/clinics" target="_blank">
              <ExternalLink />
              <span>Change Low Stock Threshold</span>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </EditLifeglovLinerStockDialog>
  );
}
